/* eslint-disable no-console */
/* eslint-disable prettier/prettier */
/* eslint-disable indent */
/* eslint-disable unicorn/prefer-module */
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { ListadoFacturas } from "../../components";
import { useAuthContext } from "../../context/auth";
import {
  getEdificiosOperativos,
  getFacturasComision2,
  getFacturasComisionTodos,
  getIntermediarios,
  getClientes,
  getOportunidadesBTL,
  log,
} from "../../utils";
import "./stylesCalculadorComisionEdificio.scss";

// Definir regexFecha fuera del componente para evitar recreaciones
const regexFecha = /^(20\d{2})-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;

// Función para detectar Safari
const isSafari = () => {
  const ua = navigator.userAgent.toLowerCase();
  return ua.includes("safari") && !ua.includes("chrome");
};

export const CalculadorComisionEdificio = () => {
  const [edificios, setEdificios] = useState([]);
  const [facturas, setFacturas] = useState(null);
  const [todosEdificios, setTodosEdificios] = useState([]);
  const [intermediarios, setIntermediarios] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [investmentType, setInvestmentType] = useState("todas");
  const [isLoading, setIsLoading] = useState(false);
  const lastFormValues = useRef({ edificio: "0", fechaInicio: "", fechaFin: "", investmentType: "todas" });

  const { pais, edificiosOk } = useAuthContext() || {};

  const logo = useMemo(
    () =>
      ({
        Chile: require("../../img/wecast-logo.png"),
        Perú: require("../../img/visiona-logo.png"),
        Uruguay: require("../../img/screenmedia-logo.png"),
        Region: require("../../img/adigital-logo.png"),
      })[pais] || require("../../img/visiona-logo.png"),
    [pais]
  );

  const { handleSubmit, register, watch } = useForm({ defaultValues: { edificio: "0" } });

  const [edificioSeleccionado, fechaInicio, fechaFin] = watch(["edificio", "fechaInicio", "fechaFin"]);

  const localString = useCallback(
    (pais) =>
      ({
        Chile: "es-CL",
        Perú: "es-PE",
        Uruguay: "es-UY",
      })[pais] || "es-UY",
    []
  );

  const moneda = useCallback(
    (pais) =>
      ({
        Chile: "$ ",
        Perú: "S/ ",
        Uruguay: "$ ",
      })[pais] || "$ ",
    []
  );

  const decimales = useCallback(
    (pais) =>
      ({
        Chile: 0,
        Perú: 2,
        Uruguay: 0,
      })[pais] || 0,
    []
  );

  useEffect(() => {
  const fetchData = async () => {
    setIsLoading(true);
    try {
      const [intermediariosData, clientesData] = await Promise.all([
        getIntermediarios(),
        getClientes({ pais }),
      ]);
      console.log("getIntermediarios response:", intermediariosData);
      console.log("getClientes response:", clientesData);
      setIntermediarios(intermediariosData || []);
      setClientes(clientesData || []);
    } catch (error) {
      console.error("fetchData error:", {
        message: error.message,
        stack: error.stack,
        name: error.name,
      });
      toast.error(`Error al cargar datos iniciales: ${error.message || "Error desconocido"}`);
    } finally {
      setIsLoading(false);
    }
  };
  fetchData();
}, [pais]);

  const calcularPantallasAjustadas = (edificio, factura) => {
    const { pantallas_ascensores, pantallas_espera, pantallas_circulacion, pantallas_cowork } = factura;
    const edificioId = edificio.id.toString();

    if (!pantallas_ascensores && !pantallas_espera && !pantallas_circulacion && !pantallas_cowork) {
      return (edificio.pantallas || 0) + (edificio.espera || 0) + (edificio.totems || 0) + (edificio.cowork || 0);
    }

    let totalPantallas = 0;
    if (pantallas_ascensores && pantallas_ascensores.split(",").includes(edificioId)) {
      totalPantallas += edificio.pantallas || 0;
    }
    if (pantallas_espera && pantallas_espera.split(",").includes(edificioId)) {
      totalPantallas += edificio.espera || 0;
    }
    if (pantallas_circulacion && pantallas_circulacion.split(",").includes(edificioId)) {
      totalPantallas += edificio.totems || 0;
    }
    if (pantallas_cowork && pantallas_cowork.split(",").includes(edificioId)) {
      totalPantallas += edificio.cowork || 0;
    }
    return totalPantallas;
  };

  const calcularNetoConIntermediario = (factura, clientes, intermediarios, pais) => {
    const cliente = clientes.find((c) => c.id === factura.client_id && c.pais === pais);
    if (!cliente) {
      return factura.importe;
    }

    const intermediarioId = cliente.agencia;
    if (!intermediarioId) {
      return factura.importe;
    }

    const intermediario = intermediarios.find((inter) => inter.id === intermediarioId && inter.pais === pais);
    if (!intermediario) {
      return factura.importe;
    }

    const fechaFactura = new Date(factura.facturafecha);
    const anoFactura =
      factura.facturafecha && !isNaN(fechaFactura.getTime()) ? fechaFactura.getFullYear() : new Date().getFullYear();
    let porcentajeComision = 0;
    if (
      intermediario.comision_2 !== null &&
      intermediario.comision_2_fechainicio &&
      intermediario.comision_2_fechafin
    ) {
      const fechaInicioIntermediario = new Date(intermediario.comision_2_fechainicio);
      const fechaFinIntermediario = new Date(intermediario.comision_2_fechafin);
      const anoInicioIntermediario = fechaInicioIntermediario.getFullYear();
      const anoFinIntermediario = fechaFinIntermediario.getFullYear();

      porcentajeComision =
        anoFactura >= anoInicioIntermediario && anoFactura <= anoFinIntermediario
          ? intermediario.comision_2 || 0
          : intermediario.comision || 0;
    } else {
      porcentajeComision = intermediario.comision || 0;
    }

    const neto = factura.importe - (factura.importe * porcentajeComision) / 100;
    return neto;
  };

  const onSubmit = useCallback(
    async (data) => {
      setIsLoading(true);
      try {
        setFacturas(null);

        let listaFacturas = [];
        let ventasBTL = [];

        const fechaInicioDate = new Date(data.fechaInicio);
        const fechaFinDate = new Date(data.fechaFin);
        if (isNaN(fechaInicioDate) || isNaN(fechaFinDate)) {
          throw new Error("Fechas inválidas");
        }
        const anoInicio = fechaInicioDate.getFullYear();
        const anoFin = fechaFinDate.getFullYear();
        const anos = [...new Set([anoInicio, anoFin])];

        const btlPromises = anos.map((ano) => getOportunidadesBTL({ pais, ano }).catch((error) => []));
        const btlResults = await Promise.all(btlPromises);
        const btlData = btlResults.flat();

        // Procesar todas las ventas BTL y evitar duplicados desde el inicio
        const uniqueBTLSales = new Map();
        btlData
          .filter((sale) => {
            const facturaFecha = new Date(sale.facturafecha);
            const isValidDate = !isNaN(facturaFecha.getTime());
            if (!isValidDate) return false;

            const buildings = sale.buildings
              ? typeof sale.buildings === "string"
                ? JSON.parse(sale.buildings)
                : sale.buildings
              : [];

            const edificioIds = buildings.map((b) => b.id);

            return (
              sale.pais === pais &&
              !sale.eliminada &&
              facturaFecha >= fechaInicioDate &&
              facturaFecha <= fechaFinDate &&
              (data.edificio === "todos" ||
                edificioIds.includes(Number(data.edificio)) ||
                todosEdificios.some((ed) => ed.alianza === data.edificio && edificioIds.includes(ed.id)))
            );
          })
          .forEach((sale) => {
            if (!uniqueBTLSales.has(sale.id)) {
              const buildings = sale.buildings
                ? typeof sale.buildings === "string"
                  ? JSON.parse(sale.buildings)
                  : sale.buildings
                : [];

              const edificioData = buildings.find((b) => b.id === Number(data.edificio)) || buildings[0];

              const cliente = clientes.find((c) => c.id === sale.client_id && c.pais === pais);
              const clienteNombre = cliente ? cliente.nombre : "SIN CLIENTE";

              uniqueBTLSales.set(sale.id, {
                id: sale.id,
                facturanumero: sale.facturanumero || "-",
                facturafecha: sale.facturafecha,
                facturafechacobro: sale.facturafechacobro,
                cliente: clienteNombre,
                importe: edificioData ? edificioData.importe : 0,
                comision: edificioData ? edificioData.comision : 0,
                edificiosUnicos: buildings.length,
                pantallastotales: 0,
                isBTL: true,
                client_id: sale.client_id,
                buildings,
              });
            }
          });

        ventasBTL = [...uniqueBTLSales.values()];
          // Mostrar toast solo si el usuario seleccionó "solo-btl" y no hay ventas BTL
          if (investmentType === "solo-btl" && ventasBTL.length === 0) {
            toast.error("No hay ventas BTL para los criterios seleccionados.");
        }

        // Mapa para acumular contribuciones financieras de BTL por edificio
        const btlContributions = new Map();
        if (investmentType !== "solo-pauta") {
          ventasBTL.forEach((sale) => {
            sale.buildings.forEach((building) => {
              const edificioId = building.id;
              if (!btlContributions.has(edificioId)) {
                btlContributions.set(edificioId, { totalFacturadoBTL: 0, netoFacturadoBTL: 0, comisionGeneradaBTL: 0 });
              }
              const contrib = btlContributions.get(edificioId);
              contrib.totalFacturadoBTL += building.importe;
              contrib.netoFacturadoBTL += building.importe; // Suponemos que neto = importe para BTL
              contrib.comisionGeneradaBTL += (building.importe * building.comision) / 100;
            });
          });
        }

        if (data.edificio === "todos") {
          if (investmentType !== "solo-btl") {
            listaFacturas = await getFacturasComisionTodos({
              edificios: todosEdificios.map((edificio) => edificio.id),
              fechas: [data.fechaInicio, data.fechaFin],
              pais,
            });
            listaFacturas = listaFacturas.map((factura) => {
              let intermediarioNombre = factura.intermediario;
              if (intermediarioNombre && !isNaN(intermediarioNombre)) {
                const intermediarioAsociado = intermediarios.find(
                  (intermediario) => intermediario.id === parseInt(intermediarioNombre)
                );
                intermediarioNombre = intermediarioAsociado ? intermediarioAsociado.nombre : "SIN INTERMEDIARIO";
              }
              return { ...factura, intermediario: intermediarioNombre, isBTL: false };
            });
          } else {
            listaFacturas = [];
          }

          if (listaFacturas.length === 0 && btlContributions.size === 0) {
            setFacturas([]);
            return;
          }

          const resumenComisionesTodos = todosEdificios
            .map((edificio) => {
              const facturasEdificio =
                investmentType !== "solo-btl"
                  ? listaFacturas.filter((factura) => factura.edificiosparticipantes.includes(edificio.id.toString()))
                  : [];

              const totalFacturadoFacturas = facturasEdificio.reduce((total, factura) => {
                const pantallasAjustadas = calcularPantallasAjustadas(edificio, factura);
                const proporcionPantallas =
                  factura.pantallastotales > 0 ? pantallasAjustadas / factura.pantallastotales : 0;
                const importeFactura = factura.importe || 0;
                const facturado = proporcionPantallas * importeFactura;
                return total + facturado;
              }, 0);

              const netoFacturadoFacturas = facturasEdificio.reduce((total, factura) => {
                const pantallasAjustadas = calcularPantallasAjustadas(edificio, factura);
                const proporcionPantallas =
                  factura.pantallastotales > 0 ? pantallasAjustadas / factura.pantallastotales : 0;
                const neto = calcularNetoConIntermediario(factura, clientes, intermediarios, pais);
                const netoProporcional = proporcionPantallas * neto;
                return total + netoProporcional;
              }, 0);

              const comisionGeneradaFacturas = facturasEdificio.reduce((total, factura) => {
                const pantallasAjustadas = calcularPantallasAjustadas(edificio, factura);
                const proporcionPantallas =
                  factura.pantallastotales > 0 ? pantallasAjustadas / factura.pantallastotales : 0;
                const neto = calcularNetoConIntermediario(factura, clientes, intermediarios, pais);
                const participacionEdificioPlata = proporcionPantallas * neto;
                const porcentajeComision =
                  factura.facturafecha >= edificio.comision_1_fechainicio &&
                  factura.facturafecha <= edificio.comision_1_fechafin
                    ? edificio.comision_1_porcentaje
                    : factura.facturafecha >= edificio.comision_2_fechainicio &&
                        factura.facturafecha <= edificio.comision_2_fechafin
                      ? edificio.comision_2_porcentaje
                      : edificio.comision_3_porcentaje;
                const comision = participacionEdificioPlata * (porcentajeComision / 100);
                return total + comision;
              }, 0);

              const btlContrib = btlContributions.get(edificio.id) || {
                totalFacturadoBTL: 0,
                netoFacturadoBTL: 0,
                comisionGeneradaBTL: 0,
              };

              const totalFacturado = totalFacturadoFacturas + btlContrib.totalFacturadoBTL;
              const netoFacturado = netoFacturadoFacturas + btlContrib.netoFacturadoBTL;
              const comisionGenerada = comisionGeneradaFacturas + btlContrib.comisionGeneradaBTL;

              return {
                edificio: edificio.edificio,
                totalFacturado,
                netoFacturado,
                comisionGenerada,
              };
            })
            .filter(
              (resumen) => resumen.totalFacturado > 0 || resumen.netoFacturado > 0 || resumen.comisionGenerada > 0
            );

          setFacturas(resumenComisionesTodos);
        } else if (todosEdificios.some((edificio) => edificio.alianza === data.edificio)) {
          const alianzaSeleccionada = data.edificio;
          const edificiosAlianza = todosEdificios.filter((edificio) => edificio.alianza === alianzaSeleccionada);

          if (investmentType !== "solo-btl") {
            listaFacturas = await getFacturasComisionTodos({
              edificios: edificiosAlianza.map((edificio) => edificio.id),
              fechas: [data.fechaInicio, data.fechaFin],
            });
            listaFacturas = listaFacturas.map((factura) => {
              let intermediarioNombre = factura.intermediario;
              if (intermediarioNombre && !isNaN(intermediarioNombre)) {
                const intermediarioAsociado = intermediarios.find(
                  (intermediario) => intermediario.id === parseInt(intermediarioNombre)
                );
                intermediarioNombre = intermediarioAsociado ? intermediarioAsociado.nombre : "SIN INTERMEDIARIO";
              }
              return { ...factura, intermediario: intermediarioNombre, isBTL: false };
            });
          } else {
            listaFacturas = [];
          }

          if (listaFacturas.length === 0 && btlContributions.size === 0) {
            setFacturas([]);
            return;
          }

          const resumenComisionesAlianza = edificiosAlianza
            .map((edificio) => {
              const facturasEdificio =
                investmentType !== "solo-btl"
                  ? listaFacturas.filter((factura) => factura.edificiosparticipantes.includes(edificio.id.toString()))
                  : [];

              const totalFacturadoFacturas = facturasEdificio.reduce((total, factura) => {
                const pantallasAjustadas = calcularPantallasAjustadas(edificio, factura);
                const proporcionPantallas =
                  factura.pantallastotales > 0 ? pantallasAjustadas / factura.pantallastotales : 0;
                const importeFactura = factura.importe || 0;
                const facturado = proporcionPantallas * importeFactura;
                return total + facturado;
              }, 0);

              const netoFacturadoFacturas = facturasEdificio.reduce((total, factura) => {
                const pantallasAjustadas = calcularPantallasAjustadas(edificio, factura);
                const proporcionPantallas =
                  factura.pantallastotales > 0 ? pantallasAjustadas / factura.pantallastotales : 0;
                const neto = calcularNetoConIntermediario(factura, clientes, intermediarios, pais);
                const netoProporcional = proporcionPantallas * neto;
                return total + netoProporcional;
              }, 0);

              const comisionGeneradaFacturas = facturasEdificio.reduce((total, factura) => {
                const pantallasAjustadas = calcularPantallasAjustadas(edificio, factura);
                const proporcionPantallas =
                  factura.pantallastotales > 0 ? pantallasAjustadas / factura.pantallastotales : 0;
                const neto = calcularNetoConIntermediario(factura, clientes, intermediarios, pais);
                const participacionEdificioPlata = proporcionPantallas * neto;
                const porcentajeComision =
                  factura.facturafecha >= edificio.comision_1_fechainicio &&
                  factura.facturafecha <= edificio.comision_1_fechafin
                    ? edificio.comision_1_porcentaje
                    : factura.facturafecha >= edificio.comision_2_fechainicio &&
                        factura.facturafecha <= edificio.comision_2_fechafin
                      ? edificio.comision_2_porcentaje
                      : edificio.comision_3_porcentaje;
                const comision = participacionEdificioPlata * (porcentajeComision / 100);
                return total + comision;
              }, 0);

              const btlContrib = btlContributions.get(edificio.id) || {
                totalFacturadoBTL: 0,
                netoFacturadoBTL: 0,
                comisionGeneradaBTL: 0,
              };

              const totalFacturado = totalFacturadoFacturas + btlContrib.totalFacturadoBTL;
              const netoFacturado = netoFacturadoFacturas + btlContrib.netoFacturadoBTL;
              const comisionGenerada = comisionGeneradaFacturas + btlContrib.comisionGeneradaBTL;

              return {
                edificio: edificio.edificio,
                totalFacturado,
                netoFacturado,
                comisionGenerada,
              };
            })
            .filter(
              (resumen) => resumen.totalFacturado > 0 || resumen.netoFacturado > 0 || resumen.comisionGenerada > 0
            );

          setFacturas(resumenComisionesAlianza);
        } else {
          const edificio = todosEdificios.find((ed) => ed.id === Number(data.edificio));
          if (!edificio) {
            setFacturas([]);
            return;
          }

          if (investmentType !== "solo-btl") {
            listaFacturas = await getFacturasComision2({
              edificio: data.edificio,
              fechas: [data.fechaInicio, data.fechaFin],
              pais,
            });
            listaFacturas = listaFacturas.map((factura) => {
              let intermediarioNombre = factura.intermediario;
              if (intermediarioNombre && !isNaN(intermediarioNombre)) {
                const intermediarioAsociado = intermediarios.find(
                  (intermediario) => intermediario.id === parseInt(intermediarioNombre)
                );
                intermediarioNombre = intermediarioAsociado ? intermediarioAsociado.nombre : "SIN INTERMEDIARIO";
              }
              return { ...factura, intermediario: intermediarioNombre, isBTL: false };
            });
          } else {
            listaFacturas = [];
          }

          const btlFiltradasSet = new Set();
          const btlFiltradas =
            investmentType !== "solo-pauta"
              ? ventasBTL.filter((sale) => {
                const isRelevant = (sale.buildings || []).some((b) => b.id === Number(data.edificio));
                if (isRelevant && !btlFiltradasSet.has(sale.id)) {
                  btlFiltradasSet.add(sale.id);
                  return true;
                }
                return false;
                })
              : [];

          const combinedListado = [
            ...(investmentType !== "solo-btl"
              ? listaFacturas.map((factura) => ({
                  ...factura,
                  edificiosUnicos: factura.edificiosparticipantes
                    ? factura.edificiosparticipantes.split(",").length
                    : 0,
                  pantallasTotales: factura.pantallastotales || 0,
                }))
              : []),
            ...(investmentType !== "solo-pauta" ? btlFiltradas : []),
          ];

          if (combinedListado.length === 0) {
            setFacturas([]);
            return;
          }

          const newFacturas = {
            comisionEdificio_1_porcentaje: edificio.comision_1_porcentaje,
            comisionEdificio_1_fechainicio: edificio.comision_1_fechainicio,
            comisionEdificio_1_fechafin: edificio.comision_1_fechafin,
            comisionEdificio_2_porcentaje: edificio.comision_2_porcentaje,
            comisionEdificio_2_fechainicio: edificio.comision_2_fechainicio,
            comisionEdificio_2_fechafin: edificio.comision_2_fechafin,
            comisionEdificio_3_porcentaje: edificio.comision_3_porcentaje,
            comisionEdificio_3_fechainicio: edificio.comision_3_fechainicio,
            comisionEdificio_3_fechafin: edificio.comision_3_fechafin,
            listado: combinedListado,
            pantallasEdificio: edificio.pantallas + edificio.totems + edificio.espera + edificio.cowork,
            edificioId: edificio.id,
          };
          setFacturas(newFacturas);
        }
      } catch (error) {
        log.error("CalculadorComisionEdificio", error);
        toast.error(`Error al procesar el informe: ${error.message}`);
        setFacturas([]);
      } finally {
        setIsLoading(false);
      }
    },
    [edificios, todosEdificios, intermediarios, pais, clientes, investmentType]
  );

  const forceSubmit = useCallback(() => {
    if (intermediarios.length === 0 || clientes.length === 0 || todosEdificios.length === 0) {
      return;
    }
    handleSubmit(onSubmit)();
  }, [handleSubmit, onSubmit, intermediarios, clientes, todosEdificios]);

  useEffect(() => {
  const initialize = async () => {
    setIsLoading(true);
    try {
      const newEdificios = await getEdificiosOperativos({ pais });
      newEdificios.sort((a, b) => a.edificio.localeCompare(b.edificio));
      setEdificios(newEdificios);

      // Filtrar edificios permitidos (excluir 121 y 119)
      const edificiosFiltrados = newEdificios.filter(ed => ed.id !== 121 && ed.id !== 119);

      const todos = !edificiosOk
        ? edificiosFiltrados
        : edificiosFiltrados.filter((edificio) => edificiosOk.includes(edificio.id));

      setTodosEdificios(todos);
    } catch (error) {
      toast.error(`Error al inicializar edificios: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };
  initialize();
}, [pais, edificiosOk]);

  useEffect(() => {
    const currentFormValues = {
      edificio: edificioSeleccionado,
      fechaInicio,
      fechaFin,
      investmentType,
    };

    const hasChanged = JSON.stringify(currentFormValues) !== JSON.stringify(lastFormValues.current);

    if (
      edificioSeleccionado !== "0" &&
      regexFecha.test(fechaInicio) &&
      regexFecha.test(fechaFin) &&
      intermediarios.length > 0 &&
      clientes.length > 0 &&
      todosEdificios.length > 0 &&
      hasChanged &&
      !isLoading
    ) {
      lastFormValues.current = currentFormValues;
      forceSubmit();
    }
  }, [
    forceSubmit,
    edificioSeleccionado,
    fechaInicio,
    fechaFin,
    investmentType,
    intermediarios,
    clientes,
    todosEdificios,
    isLoading,
  ]);

  return (
    <div className="CalculadorComisionEdificio">
      {isLoading ? (
        <p>Cargando datos...</p>
      ) : isSafari() ? (
        <div className="safari-warning">
          <p>
            Este componente solo es compatible con Google Chrome. Por favor, utiliza Chrome para acceder a esta
            funcionalidad.
          </p>
        </div>
      ) : intermediarios.length === 0 || clientes.length === 0 ? (
        <p>Error: No se pudieron cargar los datos necesarios.</p>
      ) : (
        <>
          <div className="logo-container">
            <img src={logo} alt={`${pais} Logo`} className="logo" />
          </div>
          <form className="row g-3 mb-5" onSubmit={handleSubmit(onSubmit)}>
            <div className="col-3">
              <div className="form-floating">
                <select className="form-select" {...register("edificio")}>
                  <option disabled value="0">
                    Selecciona una opción
                  </option>
                  {todosEdificios.length > 1 && <option value="todos">Todos</option>}
                  {[...new Set(todosEdificios.map((edificio) => edificio.alianza))]
                    .filter((alianza) => alianza)
                    .map((alianza) => (
                      <option key={alianza} value={alianza}>
                        {alianza}
                      </option>
                    ))}
                  {todosEdificios.map((edificio) => (
                    <option key={edificio.id} value={edificio.id}>
                      {edificio.edificio}
                    </option>
                  ))}
                </select>
                <label>1. Edificio o Alianza</label>
              </div>
            </div>
            <div className="col-3">
              <div className="form-floating">
                <input type="date" className="form-control" {...register("fechaInicio")} />
                <label>2. Fecha de Inicio</label>
              </div>
            </div>
            <div className="col-3">
              <div className="form-floating">
                <input type="date" className="form-control" {...register("fechaFin")} />
                <label>3. Fecha de Fin</label>
              </div>
            </div>
            <div className="col-3">
              <div className="form-floating">
                <select
                  className="form-select"
                  value={investmentType}
                  onChange={(e) => setInvestmentType(e.target.value)}
                >
                  <option value="todas">Todas las Inversiones</option>
                  <option value="solo-pauta">Pauta publicitaria</option>
                  <option value="solo-btl">BTL</option>
                </select>
                <label>4. Tipo de Inversión</label>
              </div>
            </div>
          </form>
          {facturas && facturas.listado && facturas.listado.length > 0 ? (
            <ListadoFacturas
              comisionEdificio_1_porcentaje={facturas.comisionEdificio_1_porcentaje}
              comisionEdificio_1_fechainicio={facturas.comisionEdificio_1_fechainicio}
              comisionEdificio_1_fechafin={facturas.comisionEdificio_1_fechafin}
              comisionEdificio_2_porcentaje={facturas.comisionEdificio_2_porcentaje}
              comisionEdificio_2_fechainicio={facturas.comisionEdificio_2_fechainicio}
              comisionEdificio_2_fechafin={facturas.comisionEdificio_2_fechafin}
              comisionEdificio_3_porcentaje={facturas.comisionEdificio_3_porcentaje}
              comisionEdificio_3_fechainicio={facturas.comisionEdificio_3_fechainicio}
              comisionEdificio_3_fechafin={facturas.comisionEdificio_3_fechafin}
              facturas={facturas.listado}
              pantallasEdificio={facturas.pantallasEdificio}
              edificioId={facturas.edificioId || null}
              pais={pais}
            />
          ) : facturas && facturas.listado && facturas.listado.length === 0 ? (
            <p>No hay ventas para este edificio en estas fechas.</p>
          ) : facturas && facturas.length > 0 ? (
            <div>
              <table className="table table-success table-bordered table-custom table-totales">
                <thead>
                  <tr className="total-row">
                    <td className="text-start">TOTALES</td>
                    <td className="text-end">{`${moneda(pais)} ${facturas
                      .reduce((total, resumen) => total + resumen.totalFacturado, 0)
                      .toLocaleString(localString(pais), {
                        minimumFractionDigits: decimales(pais),
                        maximumFractionDigits: decimales(pais),
                      })}`}</td>
                    <td className="text-end">{`${moneda(pais)} ${facturas
                      .reduce((total, resumen) => total + resumen.netoFacturado, 0)
                      .toLocaleString(localString(pais), {
                        minimumFractionDigits: decimales(pais),
                        maximumFractionDigits: decimales(pais),
                      })}`}</td>
                    <td className="text-end">{`${moneda(pais)} ${facturas
                      .reduce((total, resumen) => total + resumen.comisionGenerada, 0)
                      .toLocaleString(localString(pais), {
                        minimumFractionDigits: decimales(pais),
                        maximumFractionDigits: decimales(pais),
                      })}`}</td>
                    <td className="text-center">
                      {facturas
                        .reduce((total, resumen) => {
                          const totalComisionGenerada = facturas.reduce(
                            (total, item) => total + item.comisionGenerada,
                            0
                          );
                          const porcentajeComision = totalComisionGenerada
                            ? (resumen.comisionGenerada / totalComisionGenerada) * 100
                            : 0;
                          return total + porcentajeComision;
                        }, 0)
                        .toFixed(0)}
                      %
                    </td>
                  </tr>
                </thead>
              </table>

              <table className="table table-striped table-bordered table-hover table-custom table-detalles">
                <thead className="text-center align-middle">
                  <tr>
                    <th width="5%">#</th>
                    <th width="25%">EDIFICIO</th>
                    <th width="20%">FACTURACIÓN BRUTA</th>
                    <th width="20%">FACTURACIÓN NETA</th>
                    <th width="20%">COMISIÓN GENERADA</th>
                    <th width="10%">%</th>
                  </tr>
                </thead>
                <tbody>
                  {facturas.map((resumen, index) => {
                    const totalComisionGenerada = facturas.reduce((total, item) => total + item.comisionGenerada, 0);
                    const porcentajeComision = totalComisionGenerada
                      ? (resumen.comisionGenerada / totalComisionGenerada) * 100
                      : 0;
                    return (
                      <tr key={resumen.edificio}>
                        <td className="text-center">{index + 1}</td>
                        <td className="text-start uppercase">{resumen.edificio}</td>
                        <td className="text-end">{`${moneda(pais)} ${resumen.totalFacturado.toLocaleString(
                          localString(pais),
                          {
                            minimumFractionDigits: decimales(pais),
                            maximumFractionDigits: decimales(pais),
                          }
                        )}`}</td>
                        <td className="text-end">{`${moneda(pais)} ${resumen.netoFacturado.toLocaleString(
                          localString(pais),
                          {
                            minimumFractionDigits: decimales(pais),
                            maximumFractionDigits: decimales(pais),
                          }
                        )}`}</td>
                        <td className="text-end">{`${moneda(pais)} ${resumen.comisionGenerada.toLocaleString(
                          localString(pais),
                          {
                            minimumFractionDigits: decimales(pais),
                            maximumFractionDigits: decimales(pais),
                          }
                        )}`}</td>
                        <td className="text-center">{porcentajeComision.toFixed(1)}%</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          ) : facturas && facturas.length === 0 ? (
            <p>
              No hay ventas para{" "}
              {edificioSeleccionado === "todos"
                ? "los edificios"
                : todosEdificios.some((ed) => ed.alianza === edificioSeleccionado)
                  ? `la alianza ${edificioSeleccionado}`
                  : "este edificio"}{" "}
              en estas fechas.
            </p>
          ) : null}
        </>
      )}
    </div>
  );
};
